import React, { useContext, useEffect, useState } from 'react';
import './MassPreload.css';
import { COSMOS_API, GET_ENDPOINT, POST_ENDPOINT } from '../api/API';
import {
  ORG_SHARED_DATA,
  UserData,
  init_newUserDataObj,
} from '../interfaces/UserInterfaces';
import './PopUp.css';
import { AdminContext } from '../contexts/AdminContext';
import {
  OptionsType,
  rolePermission,
} from '../interfaces/ApplicationInterfaces';
import {
  AppEnvSetting,
  generateOptionType,
  isNullUndefEmpty,
} from '../ts/common';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import { ApplicationData, Organization, ExternalEnumRecord, ClaimValue, Claims, makeExternalEnumRecord, claimEnabledInContext, claimsListToSchema } from '../interfaces/APIInterface';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListSubheader from '@mui/material/ListSubheader';
import Container from '@mui/material/Container';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import ErrorIcon from '@mui/icons-material/Error';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import APPSETTINGS from "../settings.json";
//@ts-ignore
import { parse } from 'papaparse';
import { ApplicationClaimField } from './ApplicationClaimField';
import MenuItem from '@mui/material/MenuItem';
import Alert from '@mui/material/Alert';

enum PreloadPhase {
  DownloadTemplate = 'Download Template',
  SetSharedSettings = 'Set Shared Settings',
  UploadUsers = 'Upload Users',
}

interface PreloadResponse {
  success: boolean;
  email: string | null;
  id: string | null;
}

interface ResponsePopUpProps {
  displayData: Array<PreloadResponse>;
  setShowMsg: React.Dispatch<React.SetStateAction<boolean>>;
  showMsg: boolean;
}

interface MassPreloadProps {
  triggerPopUp: (msg: string) => void;
}

const MassPreload = (props: MassPreloadProps) => {
  const [step, setStep] = useState<PreloadPhase>(
    PreloadPhase.SetSharedSettings
  );
  const [defaultLanguage, setDefaultLanguage] = useState<string>('en-US');
  const [timezone, setTimezone] = useState<string>('');
  //const [selectedApp, setSelectedApp] = useState('');
  const [selectedApps, setSelectedApps] = useState<Array<OptionsType>>([]);
  const [defaultApp, setDefaultApp] = useState<OptionsType>();
  const [applications, setApplications] = useState<Array<OptionsType>>([]);
  const [applicationData, setApplicationData] = useState<
    Map<string, ApplicationData>
  >(new Map<string, ApplicationData>());
  const [preloadAppClaims, setPreloadAppClaims] = useState<
    Map<string, Record<string, string>>
  >(new Map<string, Record<string, string>>());
  const [setupInstructions, setSetupInstructions] = useState(false);
  const [preloadResults, setPreloadResults] = useState<Array<Array<string>>>(
    []
  );
  const [preloadRawSuccess, setPreloadRawSuccess] = useState<
    Array<Array<PreloadResponse>>
  >([]);
  const [preloadRawFailure, setPreloadRawFailure] = useState<
    Array<Array<PreloadResponse>>
  >([]);
  const [popUpData, setPopUpData] = useState<Array<PreloadResponse>>([]);
  const [showPopUp, setShowPopUp] = useState<boolean>(false);
  const [inputError, setInputError] = useState<string>('');
  const [mapToAll, setMapToAll] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);

  const { adminCredentials, getToken } = useContext(AdminContext);
  const [organizationToPreload, setOrganizationToPreload] = useState<string>(
    adminCredentials.organizationList?.length > 1 ? "" : 
    adminCredentials.organizationId
  );
  const [orgData, setOrgData] = useState<Organization>();
  const [claimsInCSV, setClaimsInCSV] = useState(false);
  const [emptyCellSetsClaim, setEmptyCellSetsClaim] = useState(false);
  const [validUserTypes, setValidUserTypes] = useState<Array<string> | null>(null);
  const [userTypeInCSV, setUserTypeInCSV] = useState(false);
  const [userType, setUserType] = useState<string|null>(null);
  const [appExternalEnums, setAppExternalEnums] = useState < Record<string, Record<string, ExternalEnumRecord> > >({});
  const [globalLevelClaims, setGlobalLevelClaims] = useState<Array<Claims>>([]);
  const [globalClaimsInCSV, setGlobalClaimsInCSV] = useState<boolean>(false);
  const [preloadGlobalClaims, setPreloadGlobalClaims] = useState<Record<string, string>>({});
  const [preloadToplevelClaims, setPreloadToplevelClaims] = useState<Record<string, string>>({});
  const possibleAppClaims = preloadAppClaims.size !== 0;
  // Show the apps the admin has access to in the dropdown
  useEffect(() => {
    /* https://stackoverflow.com/a/60907638 */
    let isMounted = true;

    if (!adminCredentials.isSuperAdmin) {
      COSMOS_API.POST(
        { permission: 'CreateUser' },
        POST_ENDPOINT.GetApplicationsWithPermission,
        getToken()
      ).then((resp) => {
        // do we need to move this to happen with every org update and use the org level app list? I think so
        let appsWithPermission: Array<string> = resp.respBody.apps;
        const apps: Array<OptionsType> = appsWithPermission.map(
          (appPermitted: any) => {
            return generateOptionType(
              adminCredentials.allApplications[appPermitted]?.name,
              appPermitted
            );
          }
        );

        if (adminCredentials.allApplications.hasOwnProperty(APPSETTINGS.msalClientId) && (!apps.some(opt => opt.value === APPSETTINGS.msalClientId)) && adminCredentials.generalPermissions.manageAdmins) {
          apps.push(generateOptionType(
            adminCredentials.allApplications[APPSETTINGS.msalClientId]?.name,
            APPSETTINGS.msalClientId
          ));
        }

        apps.sort((a, b) => (a.label <= b.label ? -1 : 1));

        if (isMounted) setApplications(apps);
      });
    } else {
      var apps: Array<OptionsType> = adminCredentials.adminApplications
        .filter((value) =>
          rolePermission(
            'createNewUsers',
            value.role,
            adminCredentials.roleSpecificPermissions,
            adminCredentials.isSuperAdmin
          )
        )
        .map((key: any) => {
          return generateOptionType(key.name, key.id);
        });
      
        if (adminCredentials.allApplications.hasOwnProperty(APPSETTINGS.msalClientId) && (!apps.some(opt => opt.value === APPSETTINGS.msalClientId)) && adminCredentials.generalPermissions.manageAdmins) {
          apps.push(generateOptionType(
            adminCredentials.allApplications[APPSETTINGS.msalClientId]?.name,
            APPSETTINGS.msalClientId
          ));
        }

      if (isMounted) setApplications(apps);
    }

    COSMOS_API.GET(GET_ENDPOINT.GetConfiguration, getToken()).then(
      (res) => {
        if (isMounted) {
          if (res?.respBody?.claims) {
            setGlobalLevelClaims(res.respBody.claims);
          }
        }
      }
    );

    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    if (!isNullUndefEmpty(organizationToPreload)) {
      COSMOS_API.POST(
        { id: organizationToPreload },
        POST_ENDPOINT.GetOrganizationData,
        getToken()
      ).then((resp) => {
        setOrgData(resp.respBody);
        if (resp.respBody.appList) {
          setSelectedApps(selectedApps.filter((app) => { return (resp.respBody.appList && resp.respBody.appList.includes(app.value)) || ((app.value === APPSETTINGS.msalClientId) && adminCredentials.generalPermissions.manageAdmins) }))
        }
      });
    }
  }, [organizationToPreload]);

  useEffect(() => {
    getAppData(selectedApps);
  }, [selectedApps]);

  const getAppData = async (selectedAppsArr: Array<OptionsType>) => {
    let newPreloadClaims = structuredClone(preloadAppClaims);

    for (const [k, _v] of newPreloadClaims) {
      if (selectedApps.find((app) => app.value === k) === undefined) {
        newPreloadClaims.delete(k);
      }
    }

    let newValidUserTypes: Array<string> | null = null;

    let newApplicationMap = structuredClone(applicationData);
    let addedApplications = [];
    for (const selectedApp of selectedAppsArr) {
      if (!newApplicationMap.has(selectedApp.value)) {
        let resp = await COSMOS_API.POST(
          { id: selectedApp.value },
          POST_ENDPOINT.GetApplicationData,
          getToken()
        );
        if (resp.ok) {
          let newAppData: ApplicationData = resp.respBody;
          newApplicationMap.set(newAppData.id, newAppData);
          addedApplications.push(newAppData)
        }
      }
      let cachedAppData = newApplicationMap.get(selectedApp.value);
      if (
        cachedAppData
      ) {
        if (cachedAppData.claims !== undefined &&
        cachedAppData.claims.length !== 0 &&
          !newPreloadClaims.has(selectedApp.value)) {
        let claimsForApp: Record<string, string> = {};
        (cachedAppData as ApplicationData).claims.forEach((clm) => {
          if (clm.userInputType !== 'CheckboxMultiSelect') { // Initialize checkboxMultiSelect to undefined for correct field behavior
            claimsForApp[clm.id] = '';
          }
        });

        newPreloadClaims.set(selectedApp.value, claimsForApp);
      }
        if (cachedAppData.allowedUserTypes) {
          if (newValidUserTypes == null) {
            newValidUserTypes = [...cachedAppData.allowedUserTypes];
          } else {
            newValidUserTypes = newValidUserTypes.filter(ut => cachedAppData!.allowedUserTypes!.includes(ut));
          }
        }
      }
    }
    setApplicationData(newApplicationMap);
    setValidUserTypes(newValidUserTypes);
    
    if ((newValidUserTypes != null) && (newValidUserTypes.length > 0) && ((userType == null) || (!newValidUserTypes.includes(userType)))) {
      setUserType(newValidUserTypes[0]);
    } else if ((newValidUserTypes == null) || (newValidUserTypes.length == 0)) {
      setUserType(null);
    }

    setPreloadAppClaims(newPreloadClaims);
    if (newPreloadClaims.size === 0) setMapToAll(false);
    else setMapToAll(true);

    let addedExtEnums: Record<string, Record<string, ExternalEnumRecord>> = {}
    for (const addedApp of addedApplications) {
      if (addedApp.claims.some(c => !!c.externalEnumeration) && (!appExternalEnums.hasOwnProperty(addedApp.id))) {
        var extEnums: Record<string, ClaimValue[]> = (await COSMOS_API.POST(
          {
            id: addedApp.id,
            orgId: organizationToPreload
          },
          POST_ENDPOINT.GetApplicationExternalEnumerations,
          getToken()
        )).respBody;
        addedExtEnums[addedApp.id] = makeExternalEnumRecord(extEnums)
      }
    }
    if (Object.keys(addedExtEnums).length > 0) {
      setAppExternalEnums({
        ...appExternalEnums,
        ...addedExtEnums
      });
    }
  };

  const sendTemplate = async () => {
    setInputError('');

    // Basic CSV
    var data = 'Email(Required),First Name(Required),Last Name(Required)';
    if ((validUserTypes != null) && (validUserTypes.length > 0) && userTypeInCSV) {
      data += ',userType';
    }
    if (globalLevelClaims && globalClaimsInCSV) {
      globalLevelClaims.forEach(gClaim => {
        let claimColumn = `,global__${gClaim.id}`;
        data += claimColumn;
      });
    }
    if (possibleAppClaims && claimsInCSV) {
      selectedApps.forEach((app) => {
        let appData = applicationData.get(app.value);
        if (
          appData !== undefined &&
          appData.claims !== undefined &&
          appData.claims.length > 0
        ) {
          appData.claims.forEach((appClaim) => {
            let claimColumn = `,app__${appData!.id}__${appClaim.id}`;
            data += claimColumn;
          });
        }
      });
    }
    var file = new Blob([data], { type: 'csv' });

    var a = document.createElement('a'),
      url = URL.createObjectURL(file);
    a.href = url;
    a.download = `masspreloadTemplate_${Date.now()}.csv`;
    document.body.appendChild(a);
    a.click();
    setTimeout(function () {
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }, 0);
  };

  const handleFileInput = (target: EventTarget & HTMLInputElement) => {
    if (target.files === null || target.files.length === 0) {
      setSelectedFile(null);
    } else {
      let targetCSV: File | null = target.files.item(0);
      setSelectedFile(targetCSV);
    }
    target.value = '';
  };

  const changePreloadAppClaim = (
    appId: string,
    claimName: string,
    claimValue: string
  ) => {
    let appClaims = preloadAppClaims.get(appId);
    if (appClaims === undefined) {
      console.log(
        `Error, there shouldn't be a claim assignment of ${claimName} to application ${
          applicationData.get(appId)!.name
        }`
      );
      return;
    }

    let newPreloadClaims = structuredClone(preloadAppClaims);
    appClaims = newPreloadClaims.get(appId)!;

    if (appClaims === undefined) {
      console.log(
        `Error, there shouldn't be a claim assignment of ${claimName} to application ${
          applicationData.get(appId)!.name
        }`
      );
      return;
    }

    appClaims[claimName] = claimValue;

    setPreloadAppClaims(newPreloadClaims);
  };

  const submitDisabled = () => {
    return isNullUndefEmpty(organizationToPreload) ||
      ((validUserTypes != null) && (validUserTypes.length == 0)) ||
      ((!globalClaimsInCSV) && (globalLevelClaims != null) && globalLevelClaims.filter(gClaim => gClaim.required).some(gClaim => gClaim.isBaseClaim ? isNullUndefEmpty(preloadToplevelClaims[gClaim.id]) : isNullUndefEmpty(preloadGlobalClaims[gClaim.id]))) ||
      ((!claimsInCSV) && (selectedApps != null) && selectedApps.some(sApp => applicationData.get(sApp.value)?.claims?.filter(aClaim => aClaim.required).some(aClaim => isNullUndefEmpty(preloadAppClaims?.get(sApp.value)?.[aClaim.id]))))
  }

  const showStep = (step: PreloadPhase) => {
    switch (step) {
      case PreloadPhase.DownloadTemplate: {
        return (
          <Grid container sx={{ mt: 2 }}>
            <Grid item sm={6}>
              <Button
                disabled={(selectedApps.length === 0) || isNullUndefEmpty(organizationToPreload) || ((validUserTypes != null) && (validUserTypes.length == 0))}
                onClick={sendTemplate}
              >
                Download template &gt;&gt;
              </Button>
            </Grid>
          </Grid>
        );
      }
      case PreloadPhase.SetSharedSettings: {
        return (
          <Box className="shared-settings">
            <Grid container>
              <Grid item container>
                <Grid item sm={6}>
                  <Box
                    sx={{
                      marginTop: '2rem',
                      marginBottom: '2rem',
                      display: adminCredentials.isSuperAdmin ? 'block' : 'none',
                    }}
                  >
                    <Autocomplete
                      id="editingOrganization"
                      className="organizationSelect"
                      fullWidth
                      disableClearable
                      disabled={!adminCredentials.isSuperAdmin}
                      value={organizationToPreload}
                      options={adminCredentials.organizationList.map(
                        (customer) => customer.id
                      )}
                      getOptionLabel={(option) =>
                        adminCredentials.organizationList.find(
                          (customer) => customer.id === option
                        )?.name ?? ''
                      }
                      renderInput={(params) => (
                        <TextField {...params} label={`Organization`} />
                      )}
                      onChange={(_, value) => setOrganizationToPreload(value)}
                    />
                  </Box>
                  <Box sx={{ marginTop: '2rem', marginBottom: '2rem' }}>
                    {orgData !== undefined && (
                      <Autocomplete
                        id="applications"
                        fullWidth
                        multiple
                        value={selectedApps}
                        isOptionEqualToValue={(
                          option: OptionsType,
                          value: OptionsType
                        ) => option.value === value.value}
                        options={applications.filter(
                          (app) =>
                          { return adminCredentials.allApplications[app.value]?.isGlobal || (orgData.appList && orgData.appList.includes(app.value)) || ((app.value === APPSETTINGS.msalClientId) && adminCredentials.generalPermissions.manageAdmins) }
                        )}
                        getOptionLabel={(option: OptionsType) => option.label}
                        renderInput={(params) => (
                          <TextField {...params} label={`Application`} />
                        )}
                        onChange={(
                          _: any,
                          value: OptionsType | OptionsType[] | null
                        ) => {
                          if (value === null) return;
                          if (!Array.isArray(value)) value = [value];
                          setSelectedApps([...value]);
                          if (
                            value.length > 0 &&
                            (defaultApp === undefined ||
                              value.find(
                                (app) => defaultApp.value === app.value
                              ) === undefined)
                          ) {
                            setDefaultApp(value[0]);
                          } else {
                            setDefaultApp(undefined);
                          }
                        }}
                      />
                    )}
                  </Box>
                  {validUserTypes && (validUserTypes.length > 0) && (
                    <>
                      <Box sx={{ marginTop: '2rem', marginBottom: '2rem' }}>
                        <Grid item sm={6}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={userTypeInCSV}
                                onChange={(e: any) => {
                                  if (e) setUserTypeInCSV(e.target.checked);
                                }}
                              />
                            }
                            label="Assign userType in CSV?"
                          />
                        </Grid>
                        {(!userTypeInCSV) && (
                          <Grid item sm={6}>
                            <TextField
                              id="selectUserType"
                              select
                              fullWidth
                              label="User Type"
                              disabled={false}
                              value={userType ? userType : validUserTypes[0] }
                              onChange={(e) => {
                                setUserType(e.target.value);
                              }}
                            >
                              {validUserTypes.map((userType) => (
                                <MenuItem key={`userType-${userType}`} value={userType}>
                                  {userType}
                                </MenuItem>
                              ))}
                            </TextField>
                          </Grid>
                        )}
                      </Box>
                    </>
                  )}
                  {validUserTypes && (validUserTypes.length == 0) && (
                    <Box sx={{ marginTop: '2rem', marginBottom: '2rem' }}>
                      <Grid item sm={6}>
                        <Alert icon={<ErrorIcon fontSize="inherit" />} variant='filled' severity='error'>
                          No user type is valid for all selected applications.
                        </Alert>
                      </Grid>
                    </Box>
                  )}
                  {globalLevelClaims && (globalLevelClaims.length > 0) && (
                    <Box sx={{ marginTop: '2rem', marginBottom: '2rem' }}>
                      <Grid item sm={6}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={globalClaimsInCSV}
                              onChange={(e: any) => {
                                if (e) setGlobalClaimsInCSV(e.target.checked);
                              }}
                            />
                          }
                          label="Assign global claims in CSV?"
                        />
                      </Grid>
                      {(!globalClaimsInCSV) && (
                        globalLevelClaims.filter(glClaim => claimEnabledInContext(glClaim, claimsListToSchema(globalLevelClaims.filter(ggClaim => ggClaim.isBaseClaim == glClaim.isBaseClaim)), glClaim.possibleValues, glClaim.isBaseClaim ? preloadToplevelClaims : preloadGlobalClaims)).map(gClaim => {
                          return (
                            <Grid key={`global-clm-${gClaim.id}`} item xs={6} sx={{ mt: 2 }}>
                              <ApplicationClaimField 
                                claim={gClaim}
                                disabled={false}
                                claimValue={gClaim.isBaseClaim ? preloadToplevelClaims[gClaim.id] : preloadGlobalClaims[gClaim.id]}
                                setClaimValue={(aid, cid, cValue) => {
                                  if (gClaim.isBaseClaim) {
                                    setPreloadToplevelClaims({ ...preloadToplevelClaims, [cid]: cValue });
                                  } else {
                                    setPreloadGlobalClaims({ ...preloadGlobalClaims, [cid]: cValue });
                                  }
                                }}
                                appId={""}
                                appExternalEnums={appExternalEnums}
                                claimContext={gClaim.isBaseClaim ? preloadToplevelClaims : preloadGlobalClaims}
                                claimSchema={claimsListToSchema(globalLevelClaims.filter(ggClaim => ggClaim.isBaseClaim == gClaim.isBaseClaim))}
                              />
                            </Grid>
                          );
                        })
                      )}
                    </Box>
                  )}
                  {possibleAppClaims && (
                    <Box sx={{ marginTop: '2rem', marginBottom: '2rem' }}>
                      <Grid item sm={6}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={claimsInCSV}
                              onChange={(e: any) => {
                                if (e) setClaimsInCSV(e.target.checked);
                              }}
                            />
                          }
                          label="Assert Application Claims in CSV?"
                        />
                      </Grid>
                      {claimsInCSV && (
                        <Grid item sm={6}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={emptyCellSetsClaim}
                                onChange={(e: any) => {
                                  if (e)
                                    setEmptyCellSetsClaim(e.target.checked);
                                }}
                              />
                            }
                            label="Should empty app claims in CSV be written to the user?"
                          />
                        </Grid>
                      )}
                    </Box>
                  )}
                  <Box sx={{ marginTop: '2rem', marginBottom: '2rem' }}>
                    {orgData !== undefined && selectedApps.length > 1 ? (
                      <Grid item>
                        <Autocomplete
                          id="defaultApplication"
                          fullWidth
                          disableClearable
                          value={defaultApp}
                          isOptionEqualToValue={(
                            option: OptionsType,
                            value: OptionsType
                          ) => option.value === value.value}
                          options={selectedApps}
                          getOptionLabel={(option: OptionsType) => option.label}
                          renderInput={(params) => (
                            <TextField {...params} label={`Default App`} />
                          )}
                          onChange={(_: any, value: OptionsType | null) => {
                            if (value === null) return;
                            setDefaultApp(value);
                          }}
                        />
                      </Grid>
                    ) : (
                      <></>
                    )}
                  </Box>
                </Grid>
              </Grid>
              {possibleAppClaims && !claimsInCSV && (
                <Grid item container spacing={2}>
                  {selectedApps.map((app) => {
                    let appData = applicationData.get(app.value);
                    if (
                      appData !== undefined &&
                      appData.claims !== undefined &&
                      appData.claims.length > 0
                    ) {
                      return (
                        <Grid item xs={6} sx={{ mt: 2 }}>
                          <Typography variant="h6">{app.label}</Typography>
                          <Stack spacing={2}>
                            {appData.claims.filter(aClaim => claimEnabledInContext(aClaim, claimsListToSchema(appData!.claims), (aClaim.externalEnumeration != null) ? ((appExternalEnums[app.value]?.[aClaim.id]?.values) ?? []) : aClaim.possibleValues, preloadAppClaims.get(app.value) ?? {})).map((claim) => {
                              return (
                                <ApplicationClaimField
                                  claim={claim}
                                  disabled={false}
                                  claimValue={preloadAppClaims.get(app.value) ?
                                    preloadAppClaims.get(app.value)![claim.id] :
                                  ''}
                                  setClaimValue={(aid, cid, cvalue) => {
                                    changePreloadAppClaim(
                                      app.value,
                                      claim.id,
                                      cvalue
                                    )
                                  }}
                                  appId={app.value}
                                  appExternalEnums={appExternalEnums}
                                  claimContext={preloadAppClaims.get(app.value) ?? {}}
                                  claimSchema={claimsListToSchema(appData!.claims)}
                                />
                              )
                            })}
                          </Stack>
                        </Grid>
                      );
                    }
                    return <></>;
                  })}
                </Grid>
              )}
              {
                //@ts-ignore
                AppEnvSetting.hideInviteEmail !== true && (
                  <Grid item container>
                    <Grid item sm={6}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={setupInstructions}
                            onChange={(e: any) => {
                              if (e) setSetupInstructions(e.target.checked);
                            }}
                          />
                        }
                        label="Email setup instructions to user?"
                      />
                    </Grid>
                  </Grid>
                )
              }
            </Grid>
          </Box>
        );
      }
      case PreloadPhase.UploadUsers: {
        return (
          <Box sx={{ mt: 2 }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  id="file-name"
                  className={selectedFile === null ? '' : 'file-name-present'}
                  value={selectedFile ? selectedFile.name : ''}
                  disabled
                  InputProps={{
                    endAdornment: (
                      <Button component="label" className="upload-file-input">
                        <input
                          hidden
                          className="hide"
                          type="file"
                          name="mass-users"
                          id="mass-users"
                          accept=".csv"
                          onChange={(e) => handleFileInput(e.target)}
                        />
                        Select CSV
                      </Button>
                    ),
                  }}
                />
              </Grid>

              <Grid item xs={12}>
                <Button
                  variant="contained"
                  disabled={(selectedFile === null) || submitDisabled()}
                  onClick={() => startMassPreload()}
                >
                  {uploading ? (
                    <span className="preload-working">Uploading</span>
                  ) : (
                    'Run MassPreload'
                  )}
                </Button>
              </Grid>
            </Grid>

            <TableContainer>
              <Table className={preloadResults.length === 0 ? 'hide' : ''}>
                <TableHead>
                  <TableRow>
                    <TableCell>Date</TableCell>
                    <TableCell>Application</TableCell>
                    <TableCell>Email?</TableCell>
                    <TableCell>Succcess?</TableCell>
                    <TableCell>Total</TableCell>
                    <TableCell>Success</TableCell>
                    <TableCell>Failed</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {preloadResults.map(
                    (result: Array<string>, index: number) => {
                      return (
                        <TableRow key={`result ${index}`}>
                          <TableCell>{result[0]}</TableCell>
                          <TableCell>{result[1]}</TableCell>
                          <TableCell>{result[2]}</TableCell>
                          <TableCell>{result[3]}</TableCell>
                          <TableCell>
                            {result[4] === 'N/A' ||
                            (setPreloadRawFailure.length === 0 &&
                              setPreloadRawSuccess.length === 0) ? (
                              result[4]
                            ) : (
                              <Button
                                className="link-imitation"
                                onClick={() => triggerPopUp('total', index)}
                              >
                                {result[4]}
                              </Button>
                            )}
                          </TableCell>
                          <TableCell>
                            {result[5] === 'N/A' ||
                            setPreloadRawSuccess.length === 0 ? (
                              result[5]
                            ) : (
                              <Button
                                className="link-imitation"
                                onClick={() => triggerPopUp('success', index)}
                              >
                                {result[5]}
                              </Button>
                            )}
                          </TableCell>
                          <TableCell>
                            {result[6] === 'N/A' ||
                            setPreloadRawFailure.length === 0 ? (
                              result[6]
                            ) : (
                              <Button
                                className="link-imitation"
                                onClick={() => triggerPopUp('failure', index)}
                              >
                                {result[6]}
                              </Button>
                            )}
                          </TableCell>
                        </TableRow>
                      );
                    }
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        );
      }
    }
  };

  const triggerPopUp = (
    type: 'total' | 'success' | 'failure',
    index: number
  ) => {
    if (type === 'success') {
      setPopUpData(preloadRawSuccess[index]);
    } else if (type === 'failure') {
      setPopUpData(preloadRawFailure[index]);
    } else {
      setPopUpData(preloadRawSuccess[index].concat(preloadRawFailure[index]));
    }
    setShowPopUp(true);
  };

  const ResponsePopUp = (props: ResponsePopUpProps) => {
    return (
      <Dialog onClose={() => props.setShowMsg(false)} open={props.showMsg}>
        <DialogTitle>Individual Results</DialogTitle>
        <DialogContent>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Success?</TableCell>
                  <TableCell>Email</TableCell>
                  <TableCell>ID</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {props.displayData.map(
                  (result: PreloadResponse, index: number) => {
                    return (
                      <TableRow key={`result ${index}`}>
                        <TableCell>{result.success.toString()}</TableCell>
                        <TableCell>{result.email}</TableCell>
                        <TableCell>{result.id}</TableCell>
                      </TableRow>
                    );
                  }
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
      </Dialog>
    );
  };

  const displayAppClaims = (appId: string): JSX.Element => {
    if (possibleAppClaims && !claimsInCSV && preloadAppClaims.has(appId)) {
      let appClaimsToDisplay = preloadAppClaims.get(appId)!;

      return (
        <>
          <br />
          <List
            key={`${appId}-displaySelectedClaims`}
            component={'div'}
            disablePadding
          >
            {Object.keys(appClaimsToDisplay).map((key) => {
              return (
                <ListItem
                  key={`${appId}-${key}-displayValue`}
                  sx={{ pl: 4, pt: 0 }}
                >
                  {key}: {appClaimsToDisplay[key]}
                </ListItem>
              );
            })}
          </List>
        </>
      );
    }
    return <></>;
  };

  const startMassPreload = async () => {
    setInputError('');
    setUploading(true);
    var currentResult: Array<string> = [];

    currentResult.push(Date());
    currentResult.push(selectedApps.map((app) => app.label).join(', '));
    currentResult.push(setupInstructions.toString());

    if (!selectedFile || selectedApps.length === 0) {
      var resultString = 'Error';
      if (!selectedFile) {
        resultString += ', invalid file';
      }
      if (selectedApps.length === 0) {
        resultString += ', no applications selected';
      }

      resultString += '.';
      setInputError(resultString);
      setUploading(false);
      return;
    }
    var reader = new FileReader();
    reader.onload = async function (e) {
      var contents = e.target!.result;
      const emailRegex = /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/;

      var users: Array<UserData> = [];
      
      var parsedUserData = parse(contents as string, {
        delimiter: "",
        header: true,
        skipEmptyLines: true
      });
      if ((!parsedUserData) || parsedUserData?.errors?.length > 0) {
        setInputError(`Errors occurred while parsing the file. Please confirm the format of the file and that each row contains the correct number of fields.`);
      }

      let noErrors = false;
      let lastParsed = 0;
      try {
        noErrors = (parsedUserData.errors.length == 0) && parsedUserData.data.every((userParseObj: any, index: number) => {
          let userDataObj = userParseObj as Record<string, string>;
          let userEmail = userDataObj["Email(Required)"]?.trim();
          let userFirstName = userDataObj["First Name(Required)"]?.trim();
          let userLastName = userDataObj["Last Name(Required)"]?.trim();
          if (!(userEmail && userFirstName && userLastName)) {
            setInputError(
              `Row ${index} has a missing core field! Please ensure that email, first name, and last name are supplied.`
            );
            return false;
          }

          if (userEmail.toLowerCase().match(emailRegex) === null) {
            setInputError(`Row ${index} has an invalid email address.`);
            return false;
          }

          let userTypeValue = null;
          if (validUserTypes != null) {
            if (!userTypeInCSV) {
              userTypeValue = userType; 
            } else {
              userTypeValue = userDataObj["userType"]?.trim();
              if (!userTypeValue) {
                setInputError(`Row ${index} is missing a value for userType!`);
                return false;
              } else if (!validUserTypes.includes(userTypeValue)) {
                setInputError(`Row ${index} has an invalid userType: ${userTypeValue}`);
                return false;
              }
            }
          }

          let orgData: Record<string, any> = {
            [ORG_SHARED_DATA]: {},
          };

          let globalAppData: Record<string, Record<string, any>> = {};

          selectedApps.forEach((app) => {
            if (adminCredentials.allApplications[app.value]?.isGlobal) {
              if (possibleAppClaims && (!claimsInCSV) && preloadAppClaims.has(app.value)) {
                globalAppData[app.value] = {
                  ...preloadAppClaims.get(app.value),
                  userProvisionStatus: 'Approved'
                };
              } else {
                globalAppData[app.value] = { userProvisionStatus: 'Approved' };
              }
            } else {
            if (possibleAppClaims && (!claimsInCSV) && preloadAppClaims.has(app.value)) {
              orgData[app.value] = {
                ...preloadAppClaims.get(app.value),
                userProvisionStatus: 'Approved',
              };
            } else {
              orgData[app.value] = { userProvisionStatus: 'Approved' };
            }
            }
          });
          let globalData: Record<string, string> = {};
          let topLevelData: Record<string, string> = {};
          if (globalLevelClaims && globalClaimsInCSV) {
            for (const columnName of Object.keys(userDataObj)) {
              if (columnName.startsWith('global__')) {
                let identifiers = columnName.split('__');
                if (identifiers.length != 2) {
                  setInputError(`Row ${index} has invalid global claim column ${columnName}.`)
                  return false;
                }
                let claimId = identifiers[1];
                let userFieldValue = userDataObj[columnName];
                let claimInfo = globalLevelClaims.find(claim => claim.id === claimId);
                let validEnumeration = false;
                if (claimInfo !== undefined) {
                  if (claimInfo.userInputType === 'DropdownSingleSelect') {
                    validEnumeration = !!(claimInfo.possibleValues?.some((val: ClaimValue) => val.value === userFieldValue));
                  } else if (claimInfo.userInputType === 'CheckboxMultiSelect') {
                    validEnumeration = (!userFieldValue) || (userFieldValue.split(",").every(fieldVal => { return claimInfo?.possibleValues?.some((val: ClaimValue) => val.value === fieldVal) }));
                  } else {
                    validEnumeration = true;
                  }
                }
                if (claimInfo && validEnumeration) {
                  if (claimInfo.isBaseClaim) {
                    topLevelData[claimInfo.id] = userFieldValue;
                  } else {
                    globalData[claimInfo.id] = userFieldValue;
                  }
                } else {
                  setInputError(`Row ${index} has an invalid claim in column name: ${columnName}. If the claim has a set of possible values it is required that a valid value be provided.`);
                  return false;
                }
              }
            }
          } else if (globalLevelClaims && (!globalClaimsInCSV)) {
            globalData = { ...globalData, ...preloadGlobalClaims };
            topLevelData = { ...topLevelData, ...preloadToplevelClaims };
          }
          if (possibleAppClaims && claimsInCSV) {
            for (const columnName of Object.keys(userDataObj)) {
              if (columnName.startsWith('app__')) {
                let identifiers = columnName.split('__');
                if (identifiers.length < 3) {
                  setInputError(`Row ${index} has invalid app claim column ${columnName}.`)
                  return false;
                }
                let appId = identifiers[1]
                let claimName = identifiers[2]
                let appData = applicationData.get(appId);
                let userFieldValue = userDataObj[columnName];
                if (appData !== undefined && appData.claims !== undefined) {
                  let validClaim = appData.claims.find(claim => claim.id === claimName);
                  let validEnumeration = false;
                  if (validClaim !== undefined) {
                    if (validClaim.userInputType === 'DropdownSingleSelect') {
                      if (appExternalEnums[appData.id]?.[validClaim.id] !== undefined) {
                        validEnumeration = appExternalEnums[appData.id][validClaim.id].values.filter(claimVal => (!validClaim?.valuesDependOn) || (userDataObj.hasOwnProperty(validClaim.valuesDependOn) && claimVal.enabledFor?.includes(userDataObj[validClaim.valuesDependOn]))).some(val => val.value === userFieldValue);
                      } else {
                        validEnumeration = !!(validClaim.possibleValues?.filter(claimVal => (!validClaim?.valuesDependOn) || (userDataObj.hasOwnProperty(validClaim.valuesDependOn) && claimVal.enabledFor?.includes(userDataObj[validClaim.valuesDependOn]))).some(val => val.value === userFieldValue));
                      }
                    } else if (validClaim.userInputType === 'CheckboxMultiSelect') {
                      if (appExternalEnums[appData.id]?.[validClaim.id] !== undefined) {
                        validEnumeration = (!userFieldValue) || (userFieldValue.split(",").every(fieldVal => { return appExternalEnums[appData!.id][validClaim!.id].values.filter(claimVal => (!validClaim?.valuesDependOn) || (userDataObj.hasOwnProperty(validClaim.valuesDependOn) && claimVal.enabledFor?.includes(userDataObj[validClaim.valuesDependOn]))).some(val => val.value === fieldVal)}));
                      } else {
                        validEnumeration = (!userFieldValue) || (userFieldValue.split(",").every(fieldVal => { return !!(validClaim!.possibleValues?.filter(claimVal => (!validClaim?.valuesDependOn) || (userDataObj.hasOwnProperty(validClaim.valuesDependOn) && claimVal.enabledFor?.includes(userDataObj[validClaim.valuesDependOn]))).some(val => val.value === fieldVal))}));
                      }
                    } else {
                      validEnumeration = true;
                    }
                  }
                  if (validClaim && validEnumeration && (emptyCellSetsClaim || userFieldValue !== '')) {
                    if (adminCredentials.allApplications[appId]?.isGlobal) {
                      if (globalAppData[appId] === undefined) {
                        globalAppData[appId] = { userProvisionStatus: 'Approved' };
                      }
                      globalAppData[appId][claimName] = userFieldValue;
                    } else {
                    if (orgData[appId] === undefined) {
                      orgData[appId] = { userProvisionStatus: 'Approved' }
                    }
                    orgData[appId][claimName] = userFieldValue;
                    }
                  } else {
                    if (!(validClaim && validEnumeration)) {
                      setInputError(`Row ${index} has an invalid claim in column name: ${columnName}. If the claim has a set of possible values it is required that a valid value be provided.`);
                      return false;
                    } else if ((userFieldValue === '') && (!emptyCellSetsClaim)) {
                      setInputError(`Row ${index} has is missing a value for claim in column name: ${columnName}.`);
                      return false;
                    } else {
                      setInputError(`Row ${index} contained an error: ${columnName}.`);
                      return false;
                    }
                  }
                }
              }
            }
          }

          var newUser = init_newUserDataObj();
          newUser = { ...newUser, ...topLevelData };
          newUser.email = userEmail;
          newUser.firstName = userFirstName;
          newUser.lastName = userLastName;
          newUser.applications = globalAppData;
          newUser.userType = userTypeValue;
          newUser.global = globalData;
          newUser.organizations = {
            [organizationToPreload]: orgData,
          };

          users.push(newUser);
          lastParsed = index;
          return true;
        });
      } catch (error) {
        setInputError(`An unexpected error occurred while parsing row ${lastParsed}. The row or file may have an invalid format.`);
        noErrors = false;
      }

      if (!noErrors) {
        setUploading(false);
        return;
      }

      const body = {
        users: [...users],
        notifyUsersThroughEmail: setupInstructions,
        defaultApplication:
          defaultApp !== undefined ? defaultApp.value : selectedApps[0].value,
      };

      const data = await COSMOS_API.POST(
        body,
        POST_ENDPOINT.BatchAddUser,
        getToken()
      );

      if (!data.ok) {
        currentResult.push(
          data.respBody.errorMessage ??
            `API returned status code of: ${data.status}`
        );
        currentResult.push('N/A');
        currentResult.push('N/A');
        currentResult.push('N/A');

        setPreloadResults([...preloadResults, currentResult]);
        setPreloadRawSuccess(preloadRawSuccess.concat([]));
        setPreloadRawFailure(preloadRawFailure.concat([]));
        setUploading(false);
        return;
      }

      currentResult.push('Yes');
      currentResult.push(data.respBody.length);
      const successes = data.respBody.filter(
        (result: any) => result.success === true
      );
      const failures = data.respBody.filter(
        (result: any) => result.success === false
      );
      currentResult.push(successes.length.toString());
      currentResult.push((data.respBody.length - successes.length).toString());

      setPreloadResults([...preloadResults, currentResult]);
      setPreloadRawSuccess(preloadRawSuccess.concat([successes]));
      setPreloadRawFailure(preloadRawFailure.concat([failures]));

      setSelectedFile(null);
      document.getElementById('file-name')!.innerHTML = '';
      setUploading(false);
    };

    reader.onloadend = (e) => {
      if (reader.result === null) {
        setInputError(`Please try reselecting your file.`);
        setSelectedFile(null);
        document.getElementById('file-name')!.innerHTML = '';
        setUploading(false);
      }
    };
    reader.readAsText(selectedFile);
  };

  const handleStepChange = (_: React.SyntheticEvent, step: number) => {
    switch (step) {
      case 0:
        setStep(PreloadPhase.SetSharedSettings);
        break;
      case 1:
        setStep(PreloadPhase.DownloadTemplate);
        break;
      case 2:
        setStep(PreloadPhase.UploadUsers);
        break;
      default:
        setStep(PreloadPhase.SetSharedSettings);
    }
  };

  const getTabValue = () =>
    step === PreloadPhase.UploadUsers
      ? 2
      : step === PreloadPhase.DownloadTemplate
      ? 1
      : 0;

  return (
    <Box>
      <ResponsePopUp
        displayData={popUpData}
        setShowMsg={setShowPopUp}
        showMsg={showPopUp}
      />
      <Box>
        <Typography variant={'h2'}>Mass Preload</Typography>
        <Grid container spacing={2}>
          <Grid item md={6}>
            <List
              aria-labelledby="mass-preload-instructions-subheader"
              subheader={
                <ListSubheader
                  component="div"
                  id="mass-preload-instructions-subheader"
                >
                  Instructions
                </ListSubheader>
              }
            >
              <ListItem>
                1. Select shared options to apply to all users. This will
                populate the Mass preload selections.
              </ListItem>
              <ListItem>
                2. Download template and provide information for up to 500
                users.
              </ListItem>
              <ListItem>3. Upload populated template and submit</ListItem>
            </List>
          </Grid>
          <Grid item md={6}>
            <List
              aria-labelledby="mass-preload-selections-subheader"
              subheader={
                <ListSubheader
                  component="div"
                  id="mass-preload-selections-subheader"
                >
                  Mass preload selections
                </ListSubheader>
              }
            >
              <ListItem>
                <Grid container>
                  <Grid item xs={2}>
                    Organization:
                  </Grid>
                  <Grid item xs={6}>
                    {(!isNullUndefEmpty(organizationToPreload))
                      ? adminCredentials.organizationList.find(
                          (org) => org.id === organizationToPreload
                        )?.name
                      : ''}
                  </Grid>
                </Grid>
              </ListItem>
              <ListItem>
                <Grid container>
                  <Grid item xs={12}>
                    Applications:
                  </Grid>
                  <Grid item xs={12}>
                    <List component={'div'} disablePadding>
                      {selectedApps.map((app) => {
                        return (
                          <ListItem
                            key={`${app.value}-selected`}
                            sx={{ pl: 4 }}
                          >
                            <Grid container>
                              <Grid item xs={12}>
                                {app.label}
                              </Grid>
                              <Grid item xs={12}>
                                {displayAppClaims(app.value)}
                              </Grid>
                            </Grid>
                          </ListItem>
                        );
                      })}
                    </List>
                  </Grid>
                </Grid>
              </ListItem>
              {/* {<ListItem>
                <label>Language:</label> {userLanguages[defaultLanguage]}
              </ListItem>
              <ListItem>
                <label>Timezone:</label> {timezone}
              </ListItem>} */}
              {/* <ListItem>
                <Grid container>
                  <Grid item xs={2}>
                    Sending Email?
                  </Grid>
                  <Grid item xs={6}>
                    {setupInstructions ? <>Yes</> : <>No</>}
                  </Grid>
                </Grid>
              </ListItem> */}
            </List>
          </Grid>
        </Grid>
        <div id="errors" className="row">
          {inputError}
        </div>
        <Container maxWidth={'xl'}>
          <Tabs
            value={getTabValue()}
            onChange={handleStepChange}
            aria-label="preload step tabs"
          >
            <Tab label={PreloadPhase.SetSharedSettings} />
            <Tab label={PreloadPhase.DownloadTemplate} />
            <Tab label={PreloadPhase.UploadUsers} />
          </Tabs>
          <div className="spacer hidden-xs"></div>
          <div className="row">{showStep(step)}</div>
        </Container>
      </Box>
      <div className="masspreload-chin"></div>
    </Box>
  );
};

export default MassPreload;
